import type React from 'react';
import type { Control, FieldValues, Path } from 'react-hook-form';
import { useController } from 'react-hook-form';
import TextField from '@mui/material/TextField';

interface EmailTextInputProps<TFields extends FieldValues> {
  name: Path<TFields>;
  label: string;
  control: Control<TFields>;
  disabled: boolean;
}

export function EmailTextInput<TFields extends FieldValues>({ name, label, control, disabled }: EmailTextInputProps<TFields>) {
  const {
    field: { ref, onBlur, onChange, value, ...fields },
    fieldState: { error },
  } = useController({
    name,
    control,
  });

  return (
    <TextField
      fullWidth
      label={label}
      value={value ?? ''}
      variant="outlined"
      inputRef={ref}
      helperText={error?.message}
      InputProps={{
        onChange,
        onBlur,
        sx: {
          '& .MuiInputBase-input': {
            flex: 1,
            paddingLeft: 1,
          },
        },
      }}
      inputProps={{
        onClick: () => {
          // Override global click-to-select behavior from MuiOutlinedInput theme
        },
        onDoubleClick: (e: React.MouseEvent<HTMLInputElement>) => {
          e.currentTarget.select();
        },
      }}
      id={`mui-component-textfield-${name}`}
      error={!!error}
      {...fields}
      disabled={disabled}
    />
  );
}
